import axios from 'src/app-axios';
import Constants from 'src/constants';

export const register = {
  namespaced: true,
  state: {
    userDetails: {},
    storedUserDetails: {},
    documentTypes: [],
  },
  getters: {
    getUserDetails (state) {
      return state.userDetails;
    },
    getStoredUserDetails (state) {
      return state.storedUserDetails;
    },
    getDocumentTypes (state) {
      return state.documentTypes;
    },
  },
  mutations: {
    setUserDetails (state, data) {
      state.userDetails = data;
    },
    setStoredUserDetails (state, data) {
      state.storedUserDetails = data;
    },
    setDocumentTypes (state, data) {
      state.documentTypes = data;
    },
  },
  actions: {
    async verifyMobileNumber ({ dispatch, commit }, payload) {
      const url = 'api/devices/service-providers/mobile-verify';
      try {
        await axios.post(url, payload);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in verifying your mobile number.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async verifyOtp ({ dispatch, commit }, payload) {
      const url = 'api/devices/service-providers/otp-verify';
      try {
        const response = await axios.post(url, payload);
        commit('setUserDetails', response.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'OTP verification failed.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    updateUserDetails (context, details) {
      context.commit('setStoredUserDetails', details);
    },
    async fetchContractorDocumentTypes ({ dispatch, commit }, payload) {
      const url = `api/devices/document-types/${payload.categoryId}`;
      try {
        const types = await axios.get(url);
        commit('setDocumentTypes', types.data);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in getting your document types list.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async uploadDocumentFiles ({ dispatch }, payload) {
      const url = `api/devices/service-providers/${payload.externalId}/upload`;
      try {
        await axios.post(url, payload.documentDetails);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in uploading your documents.',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async acceptDeclaration ({ dispatch }, payload) {
      const url = `api/devices/service-providers/${payload.externalId}/declarations`;
      try {
        await axios.post(url, payload.declarationDetails);
      } catch (exception) {
        dispatch('alert/onAlert', {
          message: 'Something went wrong in completing your registration process',
          type: Constants.ALERT_TYPE_ERROR,
        }, { root: true });
        throw exception;
      }
    },
    async registerServiceProvider ({ dispatch }, payload) {
      const url = `api/devices/service-providers/${payload.serviceProviderExtId}/verify`;
      try {
          await axios.put(url, payload.serviceProviderDetails);
      } catch (exception) {
          dispatch('alert/onAlert', {
              message: 'Something went wrong in updating your details.',
              type: Constants.ALERT_TYPE_ERROR,
          }, { root: true });
          throw exception;
      }
    },
  },
};
